import {FormErrorBox} from "common/FormErrorBox"
import {useForm} from "react-hook-form"
import {useNavigate} from "react-router-dom"
import {FlowMapper} from "dto/FlowMapper"
import {ReactNode, useEffect} from "react"
import {useRegisterMessageFlowMapper} from "hooks/query/mqtt-connectivity-query"
import {NotificationType, showNotification} from "common/Notification"

export const RegisterMessageRouteWindow = () => {
    const {register, handleSubmit, formState: {errors}, setFocus} = useForm<FlowMapper>()
    const navigate = useNavigate()
    const registerMutate = useRegisterMessageFlowMapper()
    const submit = (values: FlowMapper) => {
        registerMutate.mutate(values, {
            onSuccess: () => {
                showNotification("Message Route를 등록했습니다", NotificationType.SUCCESS)
                close()
            },
            onError: () => showNotification("Message Route를 등록하지 못했습니다")
        })
    }

    useEffect(() => {
        setFocus("name")
    }, [setFocus])

    const close = () => {
        navigate("/message-route/list")
    }
    return (
        <form onSubmit={handleSubmit(submit)}>
            <div className="modal is-active">
                <div className="modal-background" onClick={close}></div>
                <div className="modal-card model-modal">
                    <header className="modal-card-head has-background-purple">
                        <p className="modal-card-title has-text-white">Message Route 추가하기</p>
                        <div className="delete is-clickable" aria-label="close" onClick={close}></div>
                    </header>
                    <section className="modal-card-body">
                        <FormItem label="Route 이름">
                            <input className="input" type="text" placeholder="Route 이름을 입력하세요"
                                   {...register("name", {required: "Role 이름을 입력하세요",})} />
                            <FormErrorBox error={errors.name}/>
                        </FormItem>
                        <FormItem label="처리구분">
                            <select className="select is-medium " {...register("processorType")}>
                                <option value="APPLICATION_ID" className="text-xs">Application ID 방식</option>
                                <option value="BYTE_HEADER" className="text-xs">BYTE 헤더 방식</option>
                            </select>
                        </FormItem>
                        <FormItem label="구분키(App ID/Header Hex)">
                            <input className="input" type="text" placeholder="구분키를 입력하세요"
                                   {...register("headerKey", {required: "구분키를 입력하세요",})} />
                            <FormErrorBox error={errors.headerKey}/>
                        </FormItem>
                        <FormItem label="Topic (카프카)">
                            <input className="input" type="text" placeholder="Topic 을 입력하세요"
                                   {...register("topic", {required: "Topic 을 입력하세요",})} />
                            <FormErrorBox error={errors.topic}/>
                        </FormItem>

                        <div className="columns mb0">
                            <div className="column columns ">
                                <div className=" stitlebox label">메모</div>
                                <div className="column">
                                    <textarea className="textarea" placeholder="자세한 설명을 입력하세요!" rows={2}
                                              {...register("description")}/>
                                </div>
                            </div>
                        </div>


                    </section>
                    <footer className="modal-card-foot">
                        <button className="button is-purple2">추가</button>
                        <div className="button" onClick={close}>취소</div>
                    </footer>
                </div>
            </div>
        </form>
    )
}

const FormItem = ({children, label}: { label: string, children: ReactNode }) => {
    return (
        <>
            <div className="columns mb0 mt10">
                <div className="column columns">
                    <div className=" stitlebox label">{label}</div>
                    <div className="column">
                        {children}
                    </div>
                </div>
            </div>
            <div className="hr-line-dashed"></div>
        </>
    )
}